<template>
  <section>
    <div class="head">Nota da Ação: ★ {{ this.request.ratings.final }}</div>

    <div class="body">
      <div class="columns" style="padding-top: 2rem;">
        <div class="column is-one-third">
          <img
            :src="request.opportunity.page.businessLogoURL"
            style="max-width: 100px; margin: auto"
          />
        </div>

        <div class="column">
          <div class="actionInfo">
            {{ requestTypeText(request.requestType, 1) }}
            <br />

            <span v-if="request.eventInfo.title">
              {{ request.eventInfo.title }}
            </span>
            <br />

            <span v-if="request.eventInfo.dateOptions.agreed.start">
              {{
                moment(request.eventInfo.dateOptions.agreed.start).format(
                  "DD/MM/YY"
                )
              }}
            </span>
          </div>
        </div>
      </div>

      <div class="notes">
        <div
          class="titleNote"
          @click="
            isAttendeesQtyDescriptionOpen = !isAttendeesQtyDescriptionOpen
          "
        >
          Público Presente &nbsp;&nbsp;★
          {{ this.request.ratings.attendeesQty }}&nbsp;&nbsp;
          <b-icon
            icon="chevron-down"
            class="title-icon-down"
            v-if="isAttendeesQtyDescriptionOpen"
          ></b-icon>

          <b-icon icon="chevron-up" class="title-icon-up" v-else></b-icon>
        </div>

        <span class="description" v-show="isAttendeesQtyDescriptionOpen">
          Regras:<br />
          NOTA 5: Se o público presente for maior ou igual ao público
          estimado.<br />
          NOTA 3: Se o público presente for entre 99% e 75% do público
          estimado.<br />
          NOTA 0: Se o público presente for menor que 75% do público
          estimado.<br />
          *O público presente possui peso 2 no cálculo final da nota da ação.
        </span>

        <div
          class="titleNote"
          @click="isFormDescriptionOpen = !isFormDescriptionOpen"
        >
          Formulário &nbsp;&nbsp;★
          {{ this.request.ratings.form }}&nbsp;&nbsp;
          <b-icon
            icon="chevron-down"
            class="title-icon-down"
            v-if="isFormDescriptionOpen"
          ></b-icon>

          <b-icon icon="chevron-up" class="title-icon-up" v-else></b-icon>
        </div>

        <span class="description" v-show="isFormDescriptionOpen">
          Regras:<br />
          NOTA 5: Se enviou o formulário.<br />
          NOTA 0: Se não enviou o formulário.
        </span>

        <div
          class="titleNote"
          @click="isPostsDescriptionOpen = !isPostsDescriptionOpen"
        >
          Post pós-evento &nbsp;&nbsp;★
          {{ this.request.ratings.afterEventPost }}&nbsp;&nbsp;
          <b-icon
            icon="chevron-down"
            class="title-icon-down"
            v-if="isPostsDescriptionOpen"
          ></b-icon>

          <b-icon icon="chevron-up" class="title-icon-up" v-else></b-icon>
        </div>

        <span class="description" v-show="isPostsDescriptionOpen">
          Regras: <br />
          NOTA 5: Se o público presente for maior ou igual ao público
          estimado.<br />
          NOTA 3: Se o público presente for entre 99% e 75% do público
          estimado.<br />
          NOTA 0: Se o público presente for menor que 75% do público
          estimado.<br />
          *O público presente possui peso 2 no cálculo final da nota da ação.
        </span>

        <div
          class="titleNote"
          @click="isPrintsDescriptionOpen = !isPrintsDescriptionOpen"
        >
          Prints da Ação &nbsp;&nbsp;★
          {{ this.request.ratings.prints }}&nbsp;&nbsp;
          <b-icon
            icon="chevron-down"
            class="title-icon-down"
            v-if="isPrintsDescriptionOpen"
          ></b-icon>

          <b-icon icon="chevron-up" class="title-icon-up" v-else></b-icon>
        </div>

        <span class="description" v-show="isPrintsDescriptionOpen">
          Regras:<br />
          NOTA 5: Se os prints foram enviados seguindo todas as orientações.<br />
          NOTA 3: Se foram enviados menos prints do que o orientado, ou fora dos
          momentos especificados para o print.<br />
          NOTA 0: Se os prints não foram enviados.<br />
          *Os prints possuem peso 1 no cálculo final da nota da ação.
        </span>

        <div
          class="titleNote"
          @click="isOnTimeDescriptionOpen = !isOnTimeDescriptionOpen"
        >
          Fator de Pontualidade &nbsp;&nbsp;★
          {{ this.request.ratings.onTime }}&nbsp;&nbsp;
          <b-icon
            icon="chevron-down"
            class="title-icon-down"
            v-if="isOnTimeDescriptionOpen"
          ></b-icon>

          <b-icon icon="chevron-up" class="title-icon-up" v-else></b-icon>
        </div>

        <span class="description" v-show="isOnTimeDescriptionOpen">
          Regras:<br />
          Pontualidade 1: Se a OE enviou as contrapartidas até 8 dias após a
          data da ação.<br />
          Pontualidade 0,9: Se a OE enviou as contrapartidas até 15 dias após a
          data da ação.<br />
          Pontualidade 0,7: Se a OE enviou as contrapartidas até 22 dias após a
          data da ação.<br />
          Pontualidade 0,5: Se a OE enviou as contrapartidas até 30 dias após a
          data da ação.<br />
          Pontualidade 0,3: Se a OE enviou as contrapartidas após 30 dias da
          data da ação.
        </span>

        <div
          class="titleNote"
          @click="isFinalRatingDescriptionOpen = !isFinalRatingDescriptionOpen"
        >
          Cálculo da Nota &nbsp;&nbsp;★ {{ this.request.ratings.final }}&nbsp;&nbsp;
          <b-icon
            icon="chevron-down"
            class="title-icon-down"
            v-if="isFinalRatingDescriptionOpen"
          ></b-icon>

          <b-icon icon="chevron-up" class="title-icon-up" v-else></b-icon>
        </div>

        <span class="description" v-show="isFinalRatingDescriptionOpen">
          Regras:<br />
          A Nota final é calculada pela média das Notas das Contrapartidas
          multiplicadas pelo seu peso, e o valor resultante multiplicado pelo
          fator de pontualidade.<br /><br />
          ((Nota do público presente * 2 + Nota do envio do formulário * 2 +
          Nota do post + <br />
          Nota dos prints) / 6) * <br />
          Fator pontualidade = Nota Final
        </span>
      </div>
      <br />

      <div style="margin-left: auto; margin-right: auto; width: fit-content;">
        Dúvidas? Acesse o gestor Empower responsável pela ação.
      </div>
    </div>
  </section>
</template>

<script>
import { request } from "../../../mixins/request";
import { momentMixin } from "../../../mixins/moment";

export default {
  name: "StockNote",

  props: ["request"],

  mixins: [request, momentMixin],

  data() {
    return {
      isAttendeesQtyDescriptionOpen: false,
      isFormDescriptionOpen: false,
      isPostsDescriptionOpen: false,
      isPrintsDescriptionOpen: false,
      isOnTimeDescriptionOpen: false,
      isFinalRatingDescriptionOpen: false
    };
  }
};
</script>

<style scoped>
.head {
  text-align: center;
  background-color: rgb(200, 200, 200);
  font-size: 1.4rem;
  padding: 1rem;
  color: black;
  border-radius: 0.3rem 0.3rem 0 0;
}
.body {
  padding-left: 2rem;
  padding-right: 2rem;
  padding-bottom: 1rem;
}
.mainInfo {
  display: flex;
  padding-left: 1rem;
  padding-right: 1rem;
}
.mainInfo img {
  max-width: 20rem;
  width: 60%;
}
.actionInfo {
  font-size: 1.3rem;
  height: fit-content;
  margin-top: auto;
  margin-bottom: auto;
}
.titleNote {
  font-size: 1.3rem;
  font-weight: bold;
  color: black;
  margin-top: 2rem;
  margin-bottom: 0.3rem;
  cursor: pointer;
}
.title-icon-down {
  color: #aaa;
  position: relative;
  top: 4px;
}
.title-icon-up {
  color: #aaa;
  position: relative;
  top: 2px;
}
</style>
